"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Code () {
        return _connect.Code;
    },
    get ConnectError () {
        return _connect.ConnectError;
    },
    get createClient () {
        return _createClient.createClient;
    },
    get createServer () {
        return _createServer.createServer;
    }
});
const _createServer = require("./createServer.js");
const _createClient = require("./createClient.js");
const _connect = require("@connectrpc/connect");
